export default __webpack_public_path__ + "static/media/Shape 66.07b90eaa.svg";